// 适用于地区级联选择组件的树构造逻辑

export function Tree(root) {
    this.root = root;
}

Tree.prototype.insert = function (treeNode) {
    if (treeNode.parentId === this.root.id && treeNode.parentType === this.root.areaType) {
        if (Array.isArray(this.root.children)) {
            this.root.children.push(treeNode);
        } else {
            this.root.children = [treeNode];
        }
        return true;
    }
    if (this.root.children && this.root.children.length) {
        return this.root.children.some((node) => {
            const subTree = new Tree(node);
            return subTree.insert(treeNode);
        });
    }
    return false;
};

export function TreeNode({
    areaId, areaName, parentAreaId, areaType, parentType, extra,
}) {
    this.value = `${areaId}_${areaType || ''}${extra ? `_${extra}` : ''}`;
    this.label = areaName;
    this.id = +areaId;
    this.parentId = parentAreaId ? +parentAreaId : '';
    this.children = null;
    this.areaType = areaType;
    this.parentType = parentType;
}
